import { render, staticRenderFns } from "./TarefaConfiguradaComponent.vue?vue&type=template&id=7946861c"
import script from "./TarefaConfiguradaComponent.vue?vue&type=script&lang=js"
export * from "./TarefaConfiguradaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports